import { LibraryItemType } from './LibraryItem';

export enum ProjectStatus {
    Created = 'created', // draft
    Started = 'started', // after generate - clips/talks are being generated
    Ready = 'ready', // clip/talks done - processing all to one video
    Done = 'done', // video ready
    Error = 'error',
}

export interface IProject {
    type: LibraryItemType;
    id: string;
    owner_id: string;
    created_by: string;
    name: string;
    thumbnail_url: string;
    created_at: string;
    modified_at: string;
    status: ProjectStatus;
    result_url?: string;
    raw_data_url?: string;
    /** @deprecated use audio_url inside individual scenes instead */
    audio_url?: string;
    /** @deprecated use duration inside individual scenes instead */
    duration?: number;
    ready_scenes_counter: number;
    total_scenes_counter?: number;
    subtitles?: boolean;
    subtitles_url?: string;
    subtitles_urls?: Record<string, string>;
    background?: {
        color: string;
    };
}

export interface IProjectsResponse {
    projects: IProject[];
}
